import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { News } from '../models';
import { PagedOverview } from 'src/app/standalone/models/paged-overview.model';
import { BASE_URL } from '@teamfoster/sdk/ssr';

@Injectable({
  providedIn: 'root',
})
export class NewsService {
  private http = inject(HttpClient);
  private BASE_URL = inject(BASE_URL, { optional: true });

  getNewsFeatured() {
    return this.http.get<News[]>(`${this.BASE_URL}api/news/featured`);
  }

  getNewsOverview(skip: number = 0, take: number = 0) {
    return this.http.get<PagedOverview<News>>(`${this.BASE_URL}api/news?take=${take}&skip=${skip}`);
  }

  getNewsById(id: number) {
    return this.http.get<News>(`${this.BASE_URL}api/news/${id}`);
  }
}
